export default __webpack_public_path__ + "static/qr-si-f8189d0b0f5f42f29f918cc37cdb4879.svg";